import { useSearchParams } from 'next/navigation'

import { GetBrandBySlugViewModel, GetBrandCategoryViewModel, GetCategoryBySlugViewModel } from '@/types/api'
import { TagViewModel } from '@/types/cml-api'

import { useBasicMetas } from './use-basic-metas'

import { usePLPFacetsContext } from '../facets-context/facets-context'
import { PLPPages } from '../types'

export function usePageTitle() {
    const searchParams = useSearchParams()
    const { page } = usePLPFacetsContext()
    const { basicMetas } = useBasicMetas()

    if (page === PLPPages.Search) {
        const query = searchParams.get('query')
        return query ? `نتایج جست‌وجو برای "${query}"` : 'نتایج جست‌وجو'
    }

    if (!basicMetas) return null

    switch (page) {
        case PLPPages.Brands:
            return (basicMetas as GetBrandBySlugViewModel).nameFa || ''

        case PLPPages.Categories:
            return (basicMetas as GetCategoryBySlugViewModel).nameFa || ''

        case PLPPages.Combination: {
            const metas = basicMetas as GetBrandCategoryViewModel
            return `${metas?.category?.nameFa} ${metas?.brand?.nameFa}`
        }
        case PLPPages.Tags:
            return (basicMetas as TagViewModel).seoH1 || ''
    }
}
